import type { ReactNode } from 'react';

// Small neutral label - a hairline-bordered pill for low-stakes row
// metadata (e.g. "Owner" on a channel-list row). Deliberately quiet: no
// fill, no teal (teal is reserved for primary actions - see the design
// system), just muted text on a hairline border so it reads as a marker,
// not a status.
export function Badge({ children, className = '' }: { children: ReactNode; className?: string }) {
  return (
    <span
      className={`inline-flex items-center rounded-md border border-black/15 dark:border-white/20 px-1.5 py-0.5 text-[11px] font-medium leading-none text-black/55 dark:text-white/55 ${className}`}
    >
      {children}
    </span>
  );
}
